import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface IntegrationConnectedToOtherServiceTooltipProps {
  openLeft: boolean
  showToolTip?: boolean
}

const IntegrationConnectedToOtherServiceTooltip: React.FC<
  IntegrationConnectedToOtherServiceTooltipProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip
      css={css`
        z-index: 1;
      `}
      openLeft={props.openLeft}
      showToolTip={props.showToolTip}
    >
      <p>
        {translate(
          '${alreadyConnected} Because of the way these expense management integrations apply across your profile, you cannot be connected to more than one at a time.',
          {
            alreadyConnected: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate(
                  'Already connected to another expense management tool.',
                )}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default IntegrationConnectedToOtherServiceTooltip
